// removed by extract-text-webpack-plugin
module.exports = {"content":"src-templates----project-module---content---zBWvX","headerWrapper":"src-templates----project-module---headerWrapper---1zSNv","header":"src-templates----project-module---header---RGbOF","title":"src-templates----project-module---title---3jimN","information":"src-templates----project-module---information---3BvFE","infoBlock":"src-templates----project-module---infoBlock---27yDB","top":"src-templates----project-module---top---16oHs","bottom":"src-templates----project-module---bottom---28Gh9"};


//////////////////
// WEBPACK FOOTER
// ./src/templates/project.module.scss
// module id = 258
// module chunks = 29990747609436